import { getTailWindColors } from '@/utils/common';

import { SymbolLineIds } from '../config';
import {
  baseLinePaint,
  baseLinePolygonPaint,
  fenceALayer,
  fenceBLayer,
  pathLayer,
  pipelineALayer,
  pipelineBLayer,
  polygonFillPaint,
  textLayers,
  trackALayer,
  trackBLayer,
} from '.';

const { 'customize-swatch': customColor } = getTailWindColors();

const baseFilterForSpecialLines = (lineType: SymbolLineIds) => [
  'all',
  ['==', '$type', 'LineString'],
  ['==', 'user_isSpecialLine', true],
  ['==', 'user_toolId', lineType],
  ['!=', 'user_hidden', true],
];

// When the polygon is complete
export const mapboxStyles = [
  /* *********** Lines *********** */
  /* ***** Active ***** */
  {
    filter: [
      'all',
      ['==', 'active', 'false'],
      ['==', '$type', 'LineString'],
      ['!=', 'user_isSpecialLine', true],
      ['!=', 'user_hidden', true],
    ],
    id: 'gl-draw-line-inactive',
    layout: {
      'line-join': 'round',
    },
    paint: baseLinePaint(true),
    type: 'line',
  },
  /* ***** Inactive ***** */
  {
    filter: [
      'all',
      ['==', '$type', 'LineString'],
      ['==', 'active', 'true'],
      ['!=', 'user_isSpecialLine', true],
      ['!=', 'user_hidden', true],
    ],
    id: 'gl-draw-line-active',
    layout: {
      'line-join': 'round',
    },
    paint: baseLinePaint(true),
    type: 'line',
  },
  {
    ...fenceALayer(true),
    filter: baseFilterForSpecialLines(SymbolLineIds.FENCE),
  },
  {
    ...fenceBLayer(true),
    filter: baseFilterForSpecialLines(SymbolLineIds.FENCE),
  },
  {
    ...trackALayer(true),
    filter: baseFilterForSpecialLines(SymbolLineIds.TRACKS),
  },
  {
    ...trackBLayer(true),
    filter: baseFilterForSpecialLines(SymbolLineIds.TRACKS),
  },
  {
    ...pipelineALayer(true),
    filter: baseFilterForSpecialLines(SymbolLineIds.PIPELINE),
  },
  {
    ...pipelineBLayer(true),
    filter: baseFilterForSpecialLines(SymbolLineIds.PIPELINE),
  },
  { ...pathLayer(true), filter: baseFilterForSpecialLines(SymbolLineIds.PATH) },

  /* *********** Active Editing *********** */
  // Edit Dot
  {
    filter: [
      'all',
      ['==', 'meta', 'vertex'],
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static'],
      ['!=', 'user_hidden', true],
    ],
    id: 'gl-draw-polygon-and-line-vertex-inactive',
    paint: {
      'circle-color': customColor.black,
      'circle-radius': 5,
      'circle-stroke-color': customColor.white,
      'circle-stroke-width': 2,
    },
    type: 'circle',
  },
  // Midpoint dots between edit dots
  {
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['==', 'meta', 'midpoint'],
      ['!=', 'user_hidden', true],
    ],
    id: 'gl-draw-polygon-midpoint',
    paint: {
      'circle-color': customColor.white,
      'circle-radius': 6,
    },
    type: 'circle',
  },

  /* *********** Polygons *********** */
  /* ***** Active & Inactive ***** */
  {
    filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'user_hidden', true]],
    id: 'gl-draw-polygon-fill-active',
    paint: polygonFillPaint(true),
    type: 'fill',
  },
  // The lines of a complete polygon
  {
    filter: [
      'all',
      ['==', 'active', 'false'],
      ['==', '$type', 'Polygon'],
      ['!=', 'user_hidden', true],
    ],
    id: 'gl-draw-polygon-stroke-inactive',
    layout: {
      'line-join': 'round',
      visibility: 'visible',
    },
    paint: baseLinePolygonPaint(true),
    type: 'line',
  },
  {
    filter: [
      'all',
      ['==', 'active', 'true'],
      ['==', '$type', 'Polygon'],
      ['!=', 'user_hidden', true],
    ],
    id: 'gl-draw-polygon-stroke-active',
    layout: {
      'line-join': 'round',
    },
    paint: baseLinePolygonPaint(true),
    type: 'line',
  },
  ...textLayers(true),
];
